module.exports = __webpack_public_path__ + "static/media/YB5M14_2.7ba4de5b.jpg";